import { getCookie } from './config'

const tourists = '000ckys000D0Zo0fvxGdaxIMBtlCIYckys000'
export default {
  tourists,
  waptoken: getCookie('wxmalltoken') ? getCookie('wxmalltoken') : tourists,
  setwapid (newWaptoken) {
    this.waptoken = newWaptoken
    console.log(this.waptoken)
  }
}



// WEBPACK FOOTER //
// ./src/assets/common/js/wapid.js